import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredNumber,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createInventoryChangesAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        inventory_product_id: requiredUuid(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
        quantity_change: requiredNumber(),
        process_at: requiredNumber(),
        client_created_at: requiredNumber(),
        client_updated_at: requiredNumber(),
        archived_at: requiredNumber(),
    });

export const createInventoryChangesUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createInventoryChangesAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.inventory_changes,
    );

export const createInventoryChangesDeleteSchema = () => createDeleteSchema();

export const createInventoryChangesSchemas = () => ({
    add: createInventoryChangesAddSchema(),
    update: createInventoryChangesUpdateSchema(),
    delete: createInventoryChangesDeleteSchema(),
});
